var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _path6, _path7, _path8, _path9, _circle7, _rect2, _path10, _path11, _path12, _path13, _circle8, _rect3, _path14, _path15, _path16, _path17, _circle9, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoga(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 148,
    viewBox: "0 0 256 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108 106C134.51 106 156 84.5097 156 58C156 31.4903 134.51 10 108 10C81.4903 10 60 31.4903 60 58C60 84.5097 81.4903 106 108 106Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112 138C140.719 138 164 114.719 164 86C164 57.2812 140.719 34 112 34C83.2812 34 60 57.2812 60 86C60 114.719 83.2812 138 112 138Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140 148C168.719 148 192 124.719 192 96C192 67.2812 168.719 44 140 44C111.281 44 88 67.2812 88 96C88 124.719 111.281 148 140 148Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156 127C184.719 127 208 103.719 208 75C208 46.2812 184.719 23 156 23C127.281 23 104 46.2812 104 75C104 103.719 127.281 127 156 127Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143 100C169.51 100 191 78.5097 191 52C191 25.4903 169.51 4 143 4C116.49 4 95 25.4903 95 52C95 78.5097 116.49 100 143 100Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 253,
    cy: 67,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 53,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 143,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 143.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 2.5,
    r: 1.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 22,
    width: 104,
    height: 104,
    rx: 52,
    fill: "#7CAE78"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144 96V82.7656C144 81.7569 143.249 80.9061 142.248 80.781L128 79",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128 79L108 96",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152 61H108",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M130 80L130 61",
    stroke: "white",
    strokeWidth: 14
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    transform: "matrix(-1 0 0 1 136 45)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 164.881,
    y: 12,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(5 164.881 12)",
    fill: "#7CAE78"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.812 54.7919L197.433 47.6927C197.48 47.1517 197.117 46.6601 196.586 46.546L189.027 44.922",
    stroke: "white",
    strokeWidth: 3.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.026 44.9219L177.5 53.1023",
    stroke: "white",
    strokeWidth: 3.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M202.745 36.3926L179.143 34.3277",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M190.053 45.5522L190.944 35.3604",
    stroke: "white",
    strokeWidth: 7.53846
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23077,
    cy: 3.23077,
    r: 3.23077,
    transform: "matrix(-0.996195 -0.0871557 -0.0871557 0.996195 194.913 27.0596)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 84.8535,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-6 35 84.8535)",
    fill: "#7CAE78"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5086 120.767L73.7637 113.68C73.7069 113.139 73.2568 112.726 72.7138 112.715L64.9836 112.564",
    stroke: "white",
    strokeWidth: 3.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9844 112.563L55.231 122.793",
    stroke: "white",
    strokeWidth: 3.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8232 101.573L53.2607 104.05",
    stroke: "white",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1114 112.986L65.042 102.812",
    stroke: "white",
    strokeWidth: 7.53846
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.23077,
    cy: 3.23077,
    r: 3.23077,
    transform: "matrix(-0.994522 0.104528 0.104528 0.994522 67.3545 93.9062)",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M235.5 26.5L250.5 23",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M212.5 111.5L231.5 116",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25 16L44.5 23",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M6 128.5L21 125",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoga);
export default __webpack_public_path__ + "static/media/yoga.85679e6d453202724a7ca6f9d4826bee.svg";
export { ForwardRef as ReactComponent };